module.exports = __webpack_public_path__ + "img/s7pLogo1.25758000.svg";